<template>
  <header class="site__header">
    <div class="site__header__head">
      <h1>
        <a :href="constApp.route.home">
          <img src="static/img/logo.jpg" alt="第二新卒エージェントNeo登録フォーム">
        </a>
      </h1>
      <div class="site__header__head__sp">
        <div class="site__header__head__sp__inr">
          <span>登録後、内定まで無料でサポート</span>
          <ul class="site__header__head__sp__list">
            <li>平均<strong><span>113万円の年収UP</span>を実現<sup>*1</sup></strong></li>
            <li><strong><span>内定まで最短2日</span>・平均26日<sup>*2</sup></strong></li>
            <li>書類<strong><span>選考通過率94.7%</span><sup>*3</sup></strong></li>
          </ul>
        </div>
      </div>
      <h2>
        <strong><span>約8万人の20代</span>が利用中！</strong>
      </h2>
    </div>
    <div class="site__header__lead">
      <div class="site__header__lead__inr">
        <p class="site__header__lead__txt">
          <span><strong>30秒</strong>で登録完了！</span><br />適職を紹介＆無料で内定までサポート
        </p>
        <ol class="site__header__lead__list">
          <li>第二新卒エージェントneoの特長</li>
          <li>①平均<strong><span>113万円の年収UP</span>を実現<sup>*1</sup></strong></li>
          <li>②<strong><span>内定まで最短2日</span>・平均26日<sup>*2</sup></strong></li>
          <li>③書類<strong><span>選考通過率94.7%</span><sup>*3</sup></strong></li>
        </ol>
      </div>
      <p class="site__header__caption">
        <small>
          ※1 2021/04/01-2024/03/31の間で弊社を通じて内定獲得された方
        </small>
      </p>
      <p class="site__header__caption">
        <small>
          ※2 2023/03/01-2024/02/31の間で弊社を通じて内定獲得された方
        </small>
      </p>
      <p class="site__header__caption">
        <small>
          ※3 2023/3/1~2024/2/29までの1年間で弊社にて面談された方
        </small>
      </p>
    </div>
  </header>
</template>

<script>
import constMixin from '../mixins/ConstMixin'

export default {
  name: 'ChatHeader',
  mixins: [constMixin]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChatHeader.vue